import { render, staticRenderFns } from "./BetslipSummaryWithTax.vue?vue&type=template&id=534a56da&"
import script from "./BetslipSummaryWithTax.vue?vue&type=script&lang=js&"
export * from "./BetslipSummaryWithTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports